module.exports = __webpack_public_path__ + "img/mock-image-stamp.55f2f2cb.png";